import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { RegionProvider } from "./lib/regions";
import "./styles/tokens.css";
import "./styles/shell.css";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RegionProvider>
        <App />
      </RegionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
